/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateEmploymentRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateEmploymentResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateEmployment = (request: UpdateEmploymentRequest, options?: CashRequestOptions) => post<UpdateEmploymentRequest, UpdateEmploymentResponse>("/2.0/cash/update-employment", request, {...options, rejectOnError: true })